// extracted by mini-css-extract-plugin
export default {"root":"Login_root__7hP58","layout":"Login_layout__xWCqb","header":"Login_header__LK06P","logo":"Login_logo__KPy3X","title":"Login_title__pBCbQ"};